import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAddresses } from '../addressService'

export const useAddresses = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.ADDRESSES],
    queryFn: () => getAddresses(),
  })
}
